module.exports = __webpack_public_path__ + "img/ma204.15e5eceb.png";